// extracted by mini-css-extract-plugin
export var divider = "_t5-0";
export var systemMessage = "_t5-1";